import { render, staticRenderFns } from "./MomentList.vue?vue&type=template&id=f161bdb2&scoped=true&"
import script from "./MomentList.vue?vue&type=script&lang=js&"
export * from "./MomentList.vue?vue&type=script&lang=js&"
import style0 from "./MomentList.vue?vue&type=style&index=0&id=f161bdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f161bdb2",
  null
  
)

export default component.exports